interface TabNavigationProps {
  activeTab: 'restaurant' | 'forsale';
  onTabChange: (tab: 'restaurant' | 'forsale') => void;
}

export function TabNavigation({ activeTab, onTabChange }: TabNavigationProps) {
  return (
    <div className="w-full flex border-b-2 border-gray-300 bg-white relative" role="tablist">
      <button
        className={`flex-1 py-3 text-center text-base font-semibold transition-colors focus:outline-none border-x border-t rounded-t-lg ${activeTab === 'restaurant'
          ? 'bg-white text-blue-700 border-gray-300 border-b-0 z-10 shadow-sm'
          : 'bg-gray-100 text-gray-500 border-transparent hover:bg-blue-50'} `}
        onClick={() => onTabChange('restaurant')}
        aria-selected={activeTab === 'restaurant'}
        role="tab"
        tabIndex={0}
        style={{marginRight: '-2px'}}
      >
        Restaurant Ad AI
      </button>
      <button
        className={`flex-1 py-3 text-center text-base font-semibold transition-colors focus:outline-none border-x border-t rounded-t-lg ${activeTab === 'forsale'
          ? 'bg-white text-blue-700 border-gray-300 border-b-0 z-10 shadow-sm'
          : 'bg-gray-100 text-gray-500 border-transparent hover:bg-blue-50'} `}
        onClick={() => onTabChange('forsale')}
        aria-selected={activeTab === 'forsale'}
        role="tab"
        tabIndex={0}
        style={{marginLeft: '-2px'}}
      >
        For Sale AD AI
      </button>
    </div>
  );
}
